import React from 'react'
import "../../Styles/FreeBus.css";

function AadabiddaNidhi() {
  return (
 <div class="coming-soon-page">
    <div class="coming-card">
        <div class="icon">⏳</div>
        <h2>Coming Soon</h2>
        <p>This page is currently Not Avalible</p>
        <p>Please check back later.</p>
    </div>
</div>
  )
}

export default AadabiddaNidhi